import { render, staticRenderFns } from "./WarehouseInChargeTemplate.vue?vue&type=template&id=27d8bc64&scoped=true"
import script from "./WarehouseInChargeTemplate.vue?vue&type=script&lang=ts"
export * from "./WarehouseInChargeTemplate.vue?vue&type=script&lang=ts"
import style0 from "./WarehouseInChargeTemplate.vue?vue&type=style&index=0&id=27d8bc64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d8bc64",
  null
  
)

export default component.exports